import Icon from '@components/UI/Icon';
import RenderIf from '@utils/renderIf';

import capitalize from 'lodash/capitalize';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

const useBreadcrumbs = (
  pathname,
  icon,
  showHome = true,
  lastAction = false
) => {
  const roter = useRouter();
  pathname = pathname || roter.pathname;

  const pathnames = pathname.split('/').filter(Boolean);

  return (
    <ul
      className='breadcrumbs'
    >
      <RenderIf
        isTrue={ showHome }
      >
        <li>
          <Link href='/' prefetch={ false }>
            { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }
            
                            Home
            
          </Link>

          <Icon
            name={ icon }
            size={ 16 }
            color='neutral-500'
          />
        </li>
      </RenderIf>
      { pathnames.map((name, index) => {
        const href = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;

        return isLast && !lastAction ? (
          <li
            key={ name }
          >
            { capitalize(name.split('-').join(' ')) }
          </li>
        ) : (
          <li
            key={ name }
          >
            <Link href={ href } prefetch={ false }>
              { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }

              { capitalize(name.split('-').join(' ')) }

            </Link>

            <RenderIf
              isTrue={ !isLast }
            >
              <Icon
                name={ icon }
                size={ 16 }
                color='neutral-500'
              />
            </RenderIf>
          </li>
        );
      }) }
    </ul>
  );
};

export default useBreadcrumbs;
